import { render, staticRenderFns } from "./CompanyFormPanel.vue?vue&type=template&id=fa1316ba&scoped=true"
import script from "./CompanyFormPanel.vue?vue&type=script&lang=js"
export * from "./CompanyFormPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormPanel.vue?vue&type=style&index=0&id=fa1316ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1316ba",
  null
  
)

export default component.exports